import classnames from 'classnames'
import { ChangeEvent, KeyboardEvent, ReactNode } from 'react'

import styles from './textInput.module.scss'

export enum SIZES {
  SMALL = 'small',
  MEDIUM = 'medium',
}

export interface TextInputProps {
  name: string
  onChange: (event: ChangeEvent<HTMLInputElement>) => void
  value?: string
  needSubmit?: boolean
  submitButtonChildren?: ReactNode
  onSubmit?: (value?: string) => void
  size?: SIZES
  placeholder?: string
  disabled?: boolean
  className?: string
  submitButtonClassName?: string
  inputClassName?: string
  submitOnEnter?: boolean
  browserAutoComplete?: boolean
  ariaLabel?: string
}

const TextInput = ({
  placeholder = '',
  name,
  disabled = false,
  size = SIZES.MEDIUM,
  onChange,
  onSubmit,
  value,
  submitButtonChildren,
  needSubmit = false,
  className = '',
  submitButtonClassName = '',
  inputClassName = '',
  submitOnEnter = false,
  browserAutoComplete = true,
  ariaLabel,
}: TextInputProps) => {
  const wrapperClassName = classnames(
    styles.inputWrapper,
    {
      [styles.textInput__disabled as string]: disabled,
    },
    styles[`btn__${size}`],
    className,
  )

  const handleSubmit = () => {
    onSubmit?.(value)
  }

  return (
    <div className={wrapperClassName}>
      <input
        name={name}
        placeholder={placeholder}
        disabled={disabled}
        onChange={onChange}
        value={value}
        className={inputClassName}
        onKeyUp={(e: KeyboardEvent<HTMLInputElement>) => {
          if (submitOnEnter && !disabled && (e.key === 'Enter' || e.keyCode === 13)) {
            handleSubmit()
          }
        }}
        // @i18n-ignore
        autoComplete={browserAutoComplete ? 'on' : 'off'}
        aria-label={ariaLabel}
      />
      {needSubmit && (
        <button onClick={handleSubmit} className={classnames(styles.inputWrapper__cta, submitButtonClassName)}>
          {submitButtonChildren}
        </button>
      )}
    </div>
  )
}

TextInput.SIZES = SIZES

export default TextInput
